import React,{useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import { decode } from 'he';

import { Result, Button } from 'antd';
import Fade from 'react-reveal'
function QNA() {
    const dispatch = useDispatch()
    const quiz = useSelector(state=>state.quiz)
    const questions = useSelector(state=>state.quiz.questions)
    const userID = useSelector(state=>state.user.uid)
    const [index,setIndex] = useState(0)
    const [showResult,setShowResult] = useState(false)
    const [currentQuiz,setCurrentQuiz] = useState(questions[0])
    function shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
      
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
    }
    const changeQuestion=()=>{
        
        if(index<=8){
            setCurrentQuiz(questions[index+1])
            setIndex(index+1);
            console.log(index,questions[index])
        }else{
            setShowResult(true)
        }
        
    }
    const validateAnswer=(option)=>{
        if(option===currentQuiz.correct_answer){
            changeQuestion();
            dispatch({type:"INCREASE_SCORE"})
        }else{
            changeQuestion();
        }
    }
      const Options = ()=>{
          var options = currentQuiz.incorrect_answers;
          options.push(currentQuiz.correct_answer)
          options = shuffle(options)
          return options.map(option=>{
              return <div className ="option" key={`key ${option}`} onClick={()=>validateAnswer(option)}>
              { decode(option) }</div>
          })
      }
      
    return (
        <div>
        {showResult?
            <Result
            status="success"
            title="Successfully Completed the Quiz"
            subTitle={`You have won ${quiz.totalScore} coins`}
            extra={[
              <Button type="primary" key="console" onClick={()=>{
                  dispatch({type:"REQUEST_QUIZ_END",payload:{
                      coins:quiz.totalScore,
                      userID:userID
                  }
                    })
              }}>
                Get me Back
              </Button>,
              
            ]}
          />:
          <Fade left>
          <div id="question">{ decode(currentQuiz.question) }</div>
          <Options/>
          <Button style={{marginTop:30}}type="danger" shape="round" onClick={()=>dispatch({type:"RESET_QUIZ"})}>STOP QUIZ !</Button>
          </Fade>
        }
            
        </div>
    )
}

export default QNA
